import styled from 'styled-components';

import { body } from '@constants/fonts';

export const OuterSnackbar = styled.div<{
  backgroundColor: string;
  color: string;
}>`
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid ${(props) => props.color};
  border-radius: 7px;
  background-color: ${(props) => props.backgroundColor};
  box-shadow: ${({ theme }) => theme.shadows[1]};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;

  color: ${(props) => props.color};
  font-family: ${body};
  font-size: 14px;
  text-align: center;
  width: 100%;
  margin: 0px;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[6]};
  }

  &:focus {
    box-shadow: ${({ theme }) => theme.shadows[6]};
  }
`;

export const TextDiv = styled.div`
  min-width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export const Text = styled.p`
  font-size: 15px;
  padding: 10px;
  margin: 0;
`;

export const IconDiv = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-width: 10%;
  font-size: 28px;
`;

export const CloseDiv = styled.div`
  min-width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
`;
